<template>
    <div class="layout">
        <Side></Side>
        <Layout :style="{marginLeft: '200px'}">
            <Top></Top>
            <Content :style="{padding: '0 16px 16px'}">
              <Breadcrumb :style="{margin: '16px 0'}">
                  <BreadcrumbItem v-for="(item, index) in $store.state.crumbs" :key="index">{{item}}</BreadcrumbItem>
              </Breadcrumb>
             <router-view/>
          </Content>
        </Layout>
        <div class="iii" id="showLoding" >
          <Spin :fix='true' size="large">
              <Icon style="font-size:30px;" type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
              <div style="font-size:30px;">Loading</div>
          </Spin>
        </div>
    </div>
</template>


<script>
import Top from '../common/top.vue'
import Side from '../common/side.vue'
import Loding from '../common/Loding.vue';
  export default {
    name: "Layer",
    components: {
      Top,
      Side,
      Loding
      },
    data:() => {
      return {
        showLoding: false
      }
    },
    computed:{
    },
    methods:{
      getSide:()=>{
        this.axios.get(this.config.urlArray.getSide,{}).then(

        ).catch()
      }
    },
    mounted:()=>{
      
    }
  };
</script>

<style scoped>
    .layout{
      width: 100%;
      height: 100%;
        border: 1px solid #d7dde4;
        background: #f5f7f9;
        position: relative;
        border-radius: 4px;
        overflow: hidden;
    }
    .layout-header-bar{
        background: #fff;
        box-shadow: 0 1px 1px rgba(0,0,0,.1);
    }


 .demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
    .demo-spin-col{
        height: 100px;
        position: relative;
        border: 1px solid #eee;
    }
    .iii{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 99999999999999999;
        }

   .ivu-spin-fix {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 8;
      width: 100%;
      height: 100%;
      background-color: rgba(45, 45, 45, 0) !important;
  }
  #showLoding{
    display: none;
  }


</style>